import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocaleService } from '../locale/locale.service';
import type { OnDestroy } from '@angular/core';
import type { Subscription } from 'rxjs';

export enum Province {
  AB = 'AB',
  BC = 'BC',
  MB = 'MB',
  NB = 'NB',
  NL = 'NL',
  NS = 'NS',
  NT = 'NT',
  NU = 'NU',
  ON = 'ON',
  PE = 'PE',
  QC = 'QC',
  SK = 'SK',
  YT = 'YT'
}

export enum State {
  AL = 'AL',
  AK = 'AK',
  AZ = 'AZ',
  AR = 'AR',
  CA = 'CA',
  CO = 'CO',
  CT = 'CT',
  DE = 'DE',
  FL = 'FL',
  GA = 'GA',
  HI = 'HI',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  IA = 'IA',
  KS = 'KS',
  KY = 'KY',
  LA = 'LA',
  ME = 'ME',
  MD = 'MD',
  MA = 'MA',
  MI = 'MI',
  MN = 'MN',
  MS = 'MS',
  MO = 'MO',
  MT = 'MT',
  NE = 'NE',
  NV = 'NV',
  NH = 'NH',
  NJ = 'NJ',
  NM = 'NM',
  NY = 'NY',
  NC = 'NC',
  ND = 'ND',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  PA = 'PA',
  RI = 'RI',
  SC = 'SC',
  SD = 'SD',
  TN = 'TN',
  TX = 'TX',
  UT = 'UT',
  VT = 'VT',
  VA = 'VA',
  WA = 'WA',
  WV = 'WV',
  WI = 'WI',
  WY = 'WY',
  DC = 'DC',
  PR = 'PR',
  VI = 'VI',
  AS = 'AS',
  GU = 'GU',
  MP = 'MP'
}
const OTHER = 'OT';

@Injectable({
  providedIn: 'root'
})
export class ProvincesStatesCodesService implements OnDestroy {
  private readonly translateService = inject<TranslateService>(TranslateService);
  private readonly localeService = inject<LocaleService>(LocaleService);

  provinces: {
    translatedProvinces: Array<string>,
    provinceCodes: Record<string, string>
  };

  states: {
    translatedStates: Array<string>
    stateCodes: Record<string, string>,
  };

  other: { otherCountry: typeof OTHER, translatedOtherCountry: string };
  private localeChangeSubscription: Subscription;

  constructor() {
    this.localeChangeSubscription = this.localeService.onLocaleChange.subscribe((): void => {
      this.initService();
    });
  }

  ngOnDestroy(): void {
    this.localeChangeSubscription.unsubscribe();
  }

  initService(): void {
    const provinceCodes: Record<string, string> = {};
    const stateCodes: Record<string, string> = {};

    // Provinces
    const translatedProvinces: Array<string> = Object.keys(Province).map((provinceCode: string): string => {
      const translation = this.translateService.instant('tdWb.provincesStates.provinces.' + provinceCode);
      provinceCodes[translation] = provinceCode;
      return translation;
    }).sort();
    this.provinces = { translatedProvinces, provinceCodes };

    // States
    const translatedStates: Array<string> = Object.keys(State).map((stateCode: string): string => {
      const translation = this.translateService.instant('tdWb.provincesStates.states.' + stateCode);
      stateCodes[translation] = stateCode;
      return translation;
    }).sort();
    this.states = { translatedStates, stateCodes };

    // Other Country
    const translatedOtherCountry = this.translateService.instant('tdWb.provincesStates.other.' + OTHER);
    this.other = {
      translatedOtherCountry,
      otherCountry: OTHER
    };
  }

}
